import { render, staticRenderFns } from "./InsuredPersonDetails.vue?vue&type=template&id=65edf95f&"
import script from "./InsuredPersonDetails.vue?vue&type=script&lang=js&"
export * from "./InsuredPersonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports